import AppWorks from "slotworks/appworks";
import Components from "slotworks/components/components";
import { AssetConfigSchema } from "slotworks/config/asset-config-schema";
import { ComponentConfigSchema } from "slotworks/config/component-config-schema";
import { GameConfigSchema } from "slotworks/config/game-config-schema";
import { I18NConfigSchema } from "slotworks/config/i18n-config-schema";
import { SoundConfigSchema } from "slotworks/config/sound-config-schema";
import Loader from "slotworks/loader/loader";
import BetModel from "slotworks/model/bets/bet-model";
import SettingsModel from "slotworks/model/settings/settings-model";
import SlotDefinition from "slotworks/model/slot-definition";
import CommsManager from "slotworks/server/comms-manager";
import { Services } from "slotworks/services/services";
import { StateMachineConfig } from "slotworks/state-machine/parser/config/state-machine-config-schema";
import StandardStates from "slotworks/state-machine/standard/standard-states";
import IntegrationDebugger from "./debug/integration-debugger/integration-debugger";

export default class SlotWorks {

    public static go(
        gameConfig: GameConfigSchema,
        stateConfig: StateMachineConfig,
        assetConfig: AssetConfigSchema,
        componentConfig: ComponentConfigSchema,
        soundConfig: SoundConfigSchema,
        i18nConfig: I18NConfigSchema,
        ready: Function,
        autoStartStateMachine: boolean = true
    ) {

        Services.init();

        CommsManager.connector.onError((message, fatal) => Components.alert.error(message, fatal).execute());
        Loader.onError((message) => Components.alert.error(message, true).execute());

        SettingsModel.load();

        SlotDefinition.processConfig(gameConfig);
        BetModel.processConfig(gameConfig);

        BetModel.load();

        StandardStates.init();

        AppWorks.go(gameConfig, stateConfig, assetConfig, componentConfig, soundConfig, i18nConfig, ready, autoStartStateMachine);
    }

/////////////////////
////////////////////////////
/////////////////////////////////////
////////////////////////////////////////
///////////////////////////////////////
///////////////////////////////////////////////
///////////////////////////////////////
/////////////////////////////////////
///////////////////////
///////
////////////////////////////////////////////////////////////////////////////////////////////////////////////
////////////////////
//////////////////////////////////////////////////////////////////
////////////////////////////////////////
//////////////////
/////
//////////////

    private constructor() { }
}
